import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const dataProvider = {
  login: async (username, password) => {
    const response = await axios.post(`${API_URL}/token`, new URLSearchParams({ username, password }));
    return response.data;
  },

  register: async (username, email, password) => {
    const response = await axios.post(`${API_URL}/register`, { username, email, password });
    return response.data;
  },

  getList: (resource, params) => {
    return axiosInstance.get(`/${resource}`)
      .then(response => ({
        data: response.data,
        total: response.data.length,
      }));
  },

  getOne: (resource, params) =>
    axiosInstance.get(`/${resource}/${params.id}`)
      .then(response => ({ data: response.data })),

  create: (resource, params) =>
    axiosInstance.post(`/${resource}`, params.data)
      .then(response => ({
        data: response.data
      })),

  update: (resource, params) =>
    axiosInstance.put(`/${resource}/${params.id}`, params.data)
      .then(response => ({ data: response.data })),

  updateMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return axiosInstance.put(`/${resource}`, params.data, { params: query })
      .then(response => ({ data: response.data }));
  },

  delete: (resource, params) =>
    axiosInstance.delete(`/${resource}/${params.id}`)
      .then(response => ({ data: response.data })),

  deleteMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return axiosInstance.delete(`/${resource}`, { params: query })
      .then(response => ({ data: response.data }));
  },
};

export default dataProvider;